export default __webpack_public_path__ + "static/media/attach2.f3222518.svg";